var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpExpandeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7815 14.7639C15.9266 14.7454 16.0734 14.7454 16.2185 14.7639C16.4496 14.7933 16.7076 14.904 17.1093 15.2266C17.5228 15.5587 18.0109 16.0495 18.72 16.765L20.4673 18.528C20.7589 18.8222 21.2338 18.8243 21.528 18.5327C21.8222 18.2411 21.8243 17.7662 21.5327 17.472L19.7539 15.6773C19.084 15.0013 18.5364 14.4489 18.0485 14.0571C17.5412 13.6496 17.0263 13.3547 16.4082 13.2759C16.1371 13.2414 15.8629 13.2414 15.5918 13.2759C14.9737 13.3547 14.4588 13.6496 13.9515 14.0571C13.4636 14.4489 12.916 15.0013 12.2461 15.6773L10.4673 17.472C10.1757 17.7662 10.1778 18.2411 10.472 18.5327C10.7662 18.8243 11.2411 18.8222 11.5327 18.528L13.28 16.765C13.9891 16.0495 14.4772 15.5587 14.8907 15.2266C15.2924 14.904 15.5504 14.7933 15.7815 14.7639Z",
    fill: "#062A41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpExpandeIcon);
export default __webpack_public_path__ + "static/media/upExpandeIcon.4ca53a3988613ff0980cd296e9266386.svg";
export { ForwardRef as ReactComponent };